import {useState} from "react";
import {FiPlus} from "react-icons/fi";
import {useNavigate} from "react-router";

import {CreateWithAssistantButton} from "@/components/assistant/CreateWithAssistantButton.tsx";
import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButtonGroup} from "@/components/dropdownButtonGroup/DropdownButtonGroup.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {AnalyzerSource} from "@/lib/queries/analyzerRuns.ts";
import {ImportCheckModal} from "@/pages/checks/bulk-import/CheckImportModal.tsx";

export const ChecksActionBar = () => {
  const navigate = useNavigate();
  const {user, brand} = useCurrentUserContext();
  const [showImport, setShowImport] = useState(false);

  const canExport = user?.has_enterprise_features;
  if (!user) {
    return null;
  }
  if (!user.has_write_access) {
    return null;
  }

  const url = `${brand.siteURL}/devices/services/bulk-export?`;

  return (
    <div className="d-flex align-items-center">
      {user.has_write_access && (
        <div className={"d-flex gap-3"}>
          <Button size="large" variant="secondary" onClick={() => setShowImport(true)}>
            Import
          </Button>
          {canExport && (
            <DropdownButtonGroup
              as={"a"}
              title={"Export"}
              variant={"secondary"}
              className={"float-end"}
              href={`${url}&format=csv`}
            >
              <DropdownItem href={`${url}&format=xls`}>Excel</DropdownItem>
              <DropdownItem href={`${url}&format=csv`}>CSV</DropdownItem>
              <DropdownItem href={`${url}&format=json`}>JSON</DropdownItem>
            </DropdownButtonGroup>
          )}
          <CreateWithAssistantButton size="large" source={AnalyzerSource.CHECKS_LIST_ACTION_BAR} />
          <Button size="large" onClick={() => navigate(`/checks/create`)}>
            <Icon icon={FiPlus} /> Create Check
          </Button>
          <ImportCheckModal show={showImport} cancel={() => setShowImport(false)} close={() => setShowImport(false)} />
        </div>
      )}
    </div>
  );
};
